(function () {
  var KEY = 'lx_popup_seen';
  function seen() { try { return !!localStorage.getItem(KEY); } catch (e) { return false; } }
  function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  if (seen()) return;
  var path = location.pathname;
  if (/^\/(checkout|cart|account)/.test(path)) return;
  var tpl = document.getElementById('lx-popup-tpl');
  if (!tpl || !tpl.content) return;
  var shown = false, timer, lastFocus, backdrop;

  function close() {
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    var b = backdrop; backdrop = null;
    setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function onKey(e) {
    if (!backdrop) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = backdrop.querySelectorAll('button:not([hidden]),input,a[href]');
      f = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function show() {
    if (shown || seen()) return;
    shown = true; clearTimeout(timer);
    mark();
    lastFocus = document.activeElement;
    backdrop = document.createElement('div');
    backdrop.className = 'lx-popup-backdrop';
    backdrop.appendChild(tpl.content.cloneNode(true));
    document.body.appendChild(backdrop);
    var dlg = backdrop.querySelector('.lx-popup');
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); });
    backdrop.querySelector('.lx-popup__close').addEventListener('click', close);
    backdrop.querySelector('[data-lx-done]').addEventListener('click', close);
    document.addEventListener('keydown', onKey, true);
    var form = backdrop.querySelector('form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var old = form.querySelector('.lx-popup__err'); if (old) old.remove();
      btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad');
          backdrop.querySelector('[data-lx-form]').hidden = true;
          var t = backdrop.querySelector('[data-lx-thanks]');
          t.hidden = false;
          t.setAttribute('role', 'status');
          t.querySelector('button').focus();
        })
        .catch(function () {
          btn.disabled = false;
          var p = document.createElement('p');
          p.className = 'lx-popup__err'; p.setAttribute('role', 'alert');
          p.textContent = 'Sorry, that did not go through. Please check your email and try again.';
          form.insertBefore(p, btn);
        });
    });
    requestAnimationFrame(function () {
      backdrop.classList.add('is-open');
      var inp = backdrop.querySelector('input[type=email]');
      (inp || dlg).focus();
    });
  }

  timer = setTimeout(show, 25000);
  if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) show();
    });
  }
})();
